import { API_URL, getAuthHeaders } from './config';

export const showroomService = {
    getAll: async () => {
        const res = await fetch(`${API_URL}/public/showroom`);
        return res.ok ? res.json() : [];
    },
    create: async (data: any) => {
        const res = await fetch(`${API_URL}/admin/showroom`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to create item");
        return res.json();
    },
    delete: async (id: string | number) => {
        await fetch(`${API_URL}/admin/showroom/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
    }
};
